
export default {
  name: 'FocusTrap',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    selector: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      lastFocusedElement: null,
      focusableElementsString: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    };
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
    this.saveFocusedElement();
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.returnFocusedElement();
  },

  watch: {
    isOpen(value) {
      if (value) {
        this.saveFocusedElement();
      } else {
        this.returnFocusedElement();
      }
    },
  },

  methods: {
    getTrapElement() {
      if (this.selector) {
        return document.querySelector(this.selector);
      }
      return this.$refs.focusTrap;
    },

    saveFocusedElement() {
      if (!this.$isTabbingMode) {
        return;
      }

      this.lastFocusedElement = document.activeElement;

      this.$nextTick(() => {
        this.trapFocus();
      });
    },

    returnFocusedElement() {
      if (!this.$isTabbingMode) {
        return;
      }

      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
      }
    },

    trapFocus() {
      const el = this.getTrapElement();
      if (!el || !this.$isTabbingMode) {
        return;
      }

      const focusableElements = this.getFocusableElements(el);
      if (focusableElements.length) {
        focusableElements[0].focus();
      }
    },

    handleKeyDown(event) {
      const el = this.getTrapElement();
      if (event.key === 'Tab' && el) {
        const focusableElements = this.getFocusableElements(el);
        if (focusableElements.length) {
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (
            !event.shiftKey && document.activeElement === lastElement
          ) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }
    },

    getFocusableElements(el) {
      const elements = el.querySelectorAll(this.focusableElementsString);
      const visibleElements = Array.from(elements).filter((elem) => !elem.disabled && elem.offsetParent !== null);

      return visibleElements;
    },
  },
};
